var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan-loading"},[_c('div',[_vm._v("加载中...")])])
}]

export { render, staticRenderFns }